import React from 'react';
import styles from './FloTableRow.module.css';
import { FloComponentProps } from 'components';
import classnames from 'classnames';
import { FloTableRowValues, FloColumnDef, FloTableActions } from './model';
import FloActionSelector from './FloActionSelector';

export interface FloTableRowProps extends FloComponentProps {
  rowKey:         string; 
  values:         FloTableRowValues;
  columns:        FloColumnDef[];
  actions?:       FloTableActions;
  customWidths?:  boolean;
}

export const FloTableRow: React.FC<FloTableRowProps> = ({
    rowKey,
    values,
    columns,
    className,
    actions,
    name = 'flo-table-row',
    customWidths = false,
  }) => {

  const textStyle = (column: FloColumnDef, values: FloTableRowValues) => column.color ? {
    color: column.color(values)
  } : {}

  const tdStyle = (column: FloColumnDef, value: any) => column.width ? {
    width: column.width
  } : {}

  const keyValue = rowKey.split('::').map(key => values[key]).join('::');
  return (
    <tr
      className = {classnames(
        styles.root,
        className,
        { [styles.customWidths]: customWidths }
      )}
    >
      { columns.filter(col => !col.isHidden).map((col, index) => (
        <td
          key={`${name}-${keyValue}-${col.id}`}
          className={classnames(styles.rowTd, { [styles.clear]: index === 0 }, { [styles.onSelect]: col.onSelect !== undefined })}
          style={tdStyle(col, values[col.id])}
          onClick={() => col.onSelect ? col.onSelect(values) : {}}
        >
          <div style={{ width: '100%' }}>
            { col.icon && <div className={styles.icon}>{col.icon(values)}</div> }
            <div className={classnames(
              styles.text,
              { [styles.iconText]: col.icon }
            )} style={textStyle(col, values)}>{values[col.id]}</div>
          </div>
        </td>
      )) }
      { actions &&
        <td key={`${name}-${rowKey}-actions`}>
          <FloActionSelector
            keyValue = {keyValue}
            actions  = {actions}
          />
        </td>
      }
    </tr>
  );
};

export default FloTableRow;
